import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loader from '../../component/Loader';

const useHandleToken = () => {

    const navigate = useNavigate();
    const [isRedirecting, setIsRedirecting] = useState(false);



    useEffect(() => {

        setIsRedirecting(true);

        const params = new URLSearchParams(window.location.hash.split('?')[1]);

        const transaction_id = params.get('txnid');
        const eaxm_id = params.get('examid');
        const discipline_id = params.get('discipline');
        
        // const msage = params.get('status');

        sessionStorage.setItem('transaction_id', transaction_id);
        sessionStorage.setItem('eaxm_id', eaxm_id);
        sessionStorage.setItem('discipline_id', discipline_id);

        if (transaction_id && eaxm_id) {

            setTimeout(() => {
                const baseUrl = window.location.origin;
                const additionalPath = '/#/college/paymentstatus';
                const newUrl = baseUrl + additionalPath;
                window.location.href = newUrl;
            }, 1000);

        }
        else {

            localStorage.setItem('validationerror', 'login failed');
            const baseUrl = window.location.origin;
            const additionalPath = '/#/college/';
            const newUrl = baseUrl + additionalPath;
            window.location.href = newUrl;

        }

    }, [navigate]);

    return isRedirecting;
};


export default function Validation() {
    const isRedirecting = useHandleToken();

    return isRedirecting ? (
        // <div className='body23'>
        //     <div className="container23">
        //         <div className="login-box23" style={{ minHeight: "50%", alignContent: "center" }}>
        //             <div className="card-body d-flex justify-content-center align-items-center" >
        //                 <div className="containeranimate">
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                     <div className="dot"></div>
        //                 </div>
        //             </div>

        //         </div>
        //     </div>
        // </div>
        <Loader />
    ) : null;
}
